import * as React from "react";
import { AudioWaveform, Command, GalleryVerticalEnd, LayoutDashboard, Settings, Users, Brain, ArrowLeft, Scale } from "lucide-react";

import { Sidebar, SidebarContent, SidebarHeader, SidebarFooter, SidebarMenu, SidebarMenuItem, SidebarMenuButton, useSidebar } from "@/components/ui/sidebar";
import { AdminNavMain } from "./admin-nav-main";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

// This is sample data.
const data = {
    workspaces: [
        {
            name: "Finance Workspace",
            logo: AudioWaveform,
            plan: "Startup",
        },
        {
            name: "IT Workspace",
            logo: GalleryVerticalEnd,
            plan: "Enterprise",
        },
        {
            name: "HR Workspace",
            logo: Command,
            plan: "Free",
        },
    ],
    navItems: (t: any) => [
        
        {
            name: t("nav.dashboard"),
            url: "/admin/dashboard",
            icon: LayoutDashboard,
        },
        {
            name: t("nav.aiConfiguration"),
            url: "/admin/ai-configuration/connectors",
            icon: Brain,
            items: [
                {
                    name: t("nav.connectors"),
                    url: "/admin/ai-configuration/connectors",
                },
                {
                    name: t("nav.chatModels"),
                    url: "/admin/ai-configuration/chat",
                },
                {
                    name: t("nav.embeddingModels"),
                    url: "/admin/ai-configuration/embedding",
                },
                {
                    name: t("nav.embeddings"),
                    url: "/admin/ai-configuration/vector-store",
                },
                {
                    name: t("nav.personalization"),
                    url: "/admin/ai-configuration/personalization",
                },
            ],
        },
        {
            name: t("nav.userManagement"),
            url: "/admin/user-management/users",
            icon: Users,
            items: [
                {
                    name: t("nav.users"),
                    url: "/admin/user-management/users",
                },
                {
                    name: t("nav.groups"),
                    url: "/admin/user-management/groups",
                },
            ],
        },
        {
            name: t("nav.applicationSettings"),
            url: "/admin/application-settings/auth",
            icon: Settings,
            items: [
                {
                    name: t("nav.authentication"),
                    url: "/admin/application-settings/auth",
                },
                {
                    name: t("nav.application"),
                    url: "/admin/application-settings/application",
                },
                {
                    name: t("nav.smtp"),
                    url: "/admin/application-settings/smtp",
                },
                {
                    name: t("nav.notifications"),
                    url: "/admin/application-settings/notifications",
                },
                {
                    name: t("nav.sslCertificate"),
                    url: "/admin/application-settings/ssl",
                },
                {
                    name: t("nav.branding"),
                    url: "/admin/application-settings/branding",
                },
            ],
        },
        {
            name: t("nav.licenses"),
            url: "/admin/licenses",
            icon: Scale,
        },
    ],
};

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
    const { open } = useSidebar();
    const { t } = useTranslation();
    return (
        <Sidebar {...props}>
            <SidebarHeader
                className={cn(
                    "flex w-full flex-row justify-center gap-2 p-2 pt-0",
                    open && "items-center justify-start pl-2.5"
                )}
            ></SidebarHeader>
            <SidebarContent>
                <AdminNavMain items={data.navItems(t)} />
            </SidebarContent>
            <SidebarFooter className="p-2">
                <SidebarMenu>
                    <SidebarMenuItem>
                        <SidebarMenuButton asChild tooltip={t("nav.backToChat")}>
                            <a href="/">
                                <ArrowLeft className="h-4 w-4" />
                                <span>{t("nav.backToChat")}</span>
                            </a>
                        </SidebarMenuButton>
                    </SidebarMenuItem>
                </SidebarMenu>
            </SidebarFooter>
        </Sidebar>
    );
}
